import { uniquePeaks } from '@/utils/summits'
import { regionLineage } from '@/utils/regions'

// Warunki wyzwań liczone ze zdobytych szczytów (BE: api/challenge_rules.py):
//   peaks_count     { value, country?, region_id?, min_elevation? } — różne szczyty z filtrami
//   countries_count { value } — różne kraje; szczyt graniczny liczy się do każdego swojego kraju
// Front używa ich do listy „szczyty spełniające warunek” w arkuszu wyzwania; postęp liczy BE.
export const RULE_KEYS = ['peaks_count', 'countries_count']

// Reguła wyzwania, gdy ma ono dokładnie jeden taki warunek (inaczej null)
export function challengeRule(conditions) {
  const keys = Object.keys(conditions || {})
  if (keys.length !== 1 || !RULE_KEYS.includes(keys[0])) return null
  const condition = conditions[keys[0]] || {}
  const number = value => (value === null || value === undefined || value === '' ? null : Number(value))
  return {
    key: keys[0],
    value: Math.max(1, number(condition.value) || 1),
    country: condition.country ? String(condition.country).toUpperCase() : null,
    regionId: number(condition.region_id),
    minElevation: number(condition.min_elevation)
  }
}

// Zdobyte szczyty z krajami i regionem (z /api/ascents)
export function climbedPeaks(ascents = []) {
  const meta = new Map(ascents.map(ascent => [ascent.location_id, ascent]))
  return uniquePeaks(ascents).map(peak => ({
    ...peak,
    countryCodes: meta.get(peak.id)?.country_codes || [],
    regionId: meta.get(peak.id)?.region_id ?? null
  }))
}

// Zdobyte szczyty spełniające filtry peaks_count, od najwyższych
export function matchingPeaks(rule, peaks, regionIndex = null) {
  return peaks
    .filter(peak => {
      if (rule.country && !peak.countryCodes.includes(rule.country)) return false
      if (rule.minElevation !== null && peak.elevation < rule.minElevation) return false
      if (rule.regionId !== null) {
        if (peak.regionId === null || !regionIndex) return false
        if (!regionLineage(regionIndex, peak.regionId).includes(rule.regionId)) return false
      }
      return true
    })
    .sort((a, b) => b.elevation - a.elevation)
}

// Kraje zdobytych szczytów z liczbą szczytów, od największej
export function countriesSummary(peaks) {
  const counts = new Map()
  peaks.forEach(peak => peak.countryCodes.forEach(code => counts.set(code, (counts.get(code) || 0) + 1)))
  return [...counts.entries()]
    .map(([code, count]) => ({ code, count }))
    .sort((a, b) => b.count - a.count || a.code.localeCompare(b.code))
}
